export default {
    bulk_add_driver_tag_title: "Agregar Etiquetas de identificación del conductor",
    bulk_add_driver_tag_account: "Cuenta",
    bulk_add_driver_tag_id: "# Identificación",
    bulk_add_driver_tag_model: "Modelo",
    bulk_add_driver_tag_message: "Mensaje",
    bulk_add_driver_tag_repeated_in_list: "Algunas etiquetas no fueron agregadas a la lista",
    bulk_add_driver_tag_already_in_use: "Éste ID# ya se encuentra en uso y no sera importado",
    bulk_add_driver_tag_is_necessary_to_select_an_account: "Es necesario seleccionar una cuenta",
    bulk_add_driver_tag_ready_to_import: "Listo para importar",
    bulk_add_driver_tag_import_message: "Etiquetas de Identificación de conductor importada(s)",
}